// extracted by mini-css-extract-plugin
export default {"profileNavLinks":"NavList_profileNavLinks__EVrnK","active":"NavList_active__Xk14K"};